import { useState, type FormEvent } from 'react';
import { signIn } from '../lib/session';
import { Button, Field, Input } from './ui';

export function LoginScreen() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent): Promise<void> => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(username, password);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Нэвтэрч чадсангүй.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <form onSubmit={submit} className="card w-full max-w-sm p-7">
        <h1 className="text-lg font-semibold tracking-tight">Algorithm Training OS</h1>
        <p className="mt-1 text-sm text-muted">Үргэлжлүүлэхийн тулд нэвтэрнэ үү.</p>

        <div className="mt-6 space-y-4">
          <Field label="Хэрэглэгчийн нэр">
            <Input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </Field>

          <Field label="Нууц үг">
            <Input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
        </div>

        {error && (
          <p className="mt-4 rounded-lg border border-danger/40 bg-danger/10 px-3 py-2 text-sm text-danger">
            {error}
          </p>
        )}

        <Button
          type="submit"
          variant="primary"
          className="mt-6 w-full"
          disabled={busy || !username || !password}
        >
          {busy ? 'Нэвтэрч байна…' : 'Нэвтрэх'}
        </Button>

        <p className="mt-5 text-xs text-muted">
          Нэр, нууц үг нь <code className="font-mono">apps/backend/.env</code> дотор
          хадгалагдана. Энэ бол өөрийн машин дээрх түгжээ — сүлжээнд нээлттэй байвал
          хүчтэй нууц үг тавина уу.
        </p>
      </form>
    </div>
  );
}
